import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { importsSalesforceStartPostSlice } from './post';

export const importsSalesforceStartReducers = combineReducers({
	post: importsSalesforceStartPostSlice.asyncReducers
});

export const importsSalesforceStartWatchers = combineAllWatchers([
	importsSalesforceStartPostSlice.asyncWatchers
]);
